import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import Route from '../route/Route';
import { RoutePath } from '../route/type';
import { StyledGlow, StyledLogo } from './styled';

const SX_ROUTE: SxProps<Theme> = {
  '&:after': { display: 'none' },
  display: 'inline-block',
  marginTop: { lg: 'calc(var(--logo) * 1/8)', xs: 'calc(var(--logo-m) * 1/8)' },
  position: 'absolute',
};

const SX_IMAGE: SxProps<Theme> = {
  height: { lg: 'calc(var(--logo) * 7/8)', xs: 'calc(var(--logo-m) * 7/8)' },
  width: { lg: 'var(--logo)', xs: 'var(--logo-m)' },
};

type LogoProps = {
  glow?: boolean;
  onClick?: () => void;
};

const Logo: FC<LogoProps> = ({ glow = false, onClick }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<string>('0px');

  useEffect(() => {
    const handleResize = (): void => setLeft((document.body.clientWidth >> 1) + 'px');
    handleResize();

    window.addEventListener('resize', handleResize);
    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const sxLogo = useMemo<SxProps<Theme>>(() => ({ left }), [left]);
  const click = useCallback(() => onClick?.(), [onClick]);

  return (
    <StyledLogo onClick={click} ref={ref} sx={sxLogo}>
      {glow && <StyledGlow />}
      <Route href={RoutePath.Home} sx={SX_ROUTE}>
        <Box
          alt='KriegerSein Falko Zander'
          component='img'
          src='/img/logo-kriegersein-falko-zander-gold.svg'
          sx={SX_IMAGE}
        />
      </Route>
    </StyledLogo>
  );
};

export default Logo;
